export const convoysUrl = 'convoys/';
export const convoyUrl = (convoyId: string) => `convoys/${convoyId}/`;
export const convoyEvaluationsUrl = (convoyId: string) => `convoys/${convoyId}/evaluations/`;
